import React from "react";
import {
  generatePath,
  Link,
  Navigate,
  useMatch,
  useNavigate,
  useParams,
} from "react-router-dom";

import {
  purchaseOrderGeneralRoute,
  purchaseOrderOverviewRoute,
  purchaseOrderProductsRoute,
} from "./paths";
import { NavigateOptions } from "react-router/dist/lib/context";

export const PurchaseOrderOverviewNavigation = () => (
  <Navigate
    to={generatePath(purchaseOrderOverviewRoute, useParams())}
    replace
  />
);

export const PurchaseOrderProductsLink: React.FC<{
  poId: string;
}> = ({ poId, children }) => (
  <Link
    to={generatePath(purchaseOrderProductsRoute, { id: poId })}
    children={children}
    replace={false}
  />
);

export const useNavigateToPurchaseOrderOverview = () => {
  const navigate = useNavigate();
  const path = usePurchaseOrderOverviewPath();
  return (options?: NavigateOptions) =>
    navigate(path, { replace: false, ...options });
};
export const useNavigateToPurchaseOrderProducts = () => {
  const navigate = useNavigate();
  const path = usePurchaseOrderProductsPath();
  return (options?: NavigateOptions) =>
    navigate(path, { replace: false, ...options });
};

const usePurchaseOrderOverviewPath = () =>
  generatePath(purchaseOrderOverviewRoute, useParams());
const usePurchaseOrderProductsPath = () =>
  generatePath(purchaseOrderProductsRoute, useParams());

export const useActiveTab = () => {
  const match = useMatch(purchaseOrderGeneralRoute);
  return (match?.params.activeTab as "overview" | "products") ?? undefined;
};
